// src/contexts/PlaceContext.js
import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';
import { fetchWithRetry } from '../utils/fetchWithRetry';

export const PlaceContext = createContext();

export const PlaceProvider = ({ children }) => {
  const [places, setPlaces] = useState([]);
  const [loadingPlaces, setLoadingPlaces] = useState(true);
  const [errorPlaces, setErrorPlaces] = useState(null);

  const PLACES_API_URL =
    'https://admin.thirsty-shtern.91-151-16-181.plesk.page/items/Standorte?fields=*';

  useEffect(() => {
    const ac = new AbortController();
    const fetchPlaces = async () => {
      setLoadingPlaces(true); setErrorPlaces(null);
      try {
        const res = await fetchWithRetry(
          () => axios.get(PLACES_API_URL, { signal: ac.signal }),
          { retries: 3, baseDelay: 300, signal: ac.signal }
        );
        setPlaces(res?.data?.data ?? []);
      } catch (e) {
        if (!ac.signal.aborted) setErrorPlaces('Fehler beim Laden der Standorte');
      } finally {
        if (!ac.signal.aborted) setLoadingPlaces(false);
      }
    };
    fetchPlaces();
    /* return () => ac.abort(); */
  }, []);

  return (
    <PlaceContext.Provider value={{ places, loadingPlaces, errorPlaces }}>
      {children}
    </PlaceContext.Provider>
  );
};
